import { styled } from '@zoopla-eng/zds-components/themes';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';

export const FaqWrapper = styled('div', {
    '& ul, & ol': {
        paddingLeft: 0,
        rowGap: '$S400',

        '& li': {
            '& p': {
                margin: 0
            },
            '& ul, & ol': {
                marginTop: '$S400',
                marginBottom: 0
            }
        }
    },

    '& p': {
        textAlign: 'left'
    }
});

export const FaqTitle = styled(PageSubtitleShort, {
    marginBottom: '$S300'
});

export const FaqDescription = styled('p', {
    marginBottom: '$S400',
    fontGroup: 'ladle',
    color: '$textTitle'
});
